<template>
  <div>
    <CSPLoader v-if="loading" />

    <div>
      <v-container grid-list-md>
        <div v-if="location">
          <v-card-text class="px-0" v-if="recentLocation.length > 1">
            <ChangeLocation
              v-if="location"
              :location="location"
              @submit="getEmployeesList()"
            />
          </v-card-text>
          <h5 v-else class="text-center">{{ location.name }}</h5>
        </div>
        <v-layout row>
          <v-flex xs6>
            <v-card class="rounded-lg" color="green" dark>
              <v-card-text class="pa-0">
                <v-layout column>
                  <v-flex xs12 class="white--text text-center">
                    Clock In
                  </v-flex>
                  <v-flex
                    xs12
                    class="white--text text-center display-1 font-weight-bold"
                  >
                    {{ count.clockIn }}
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs6>
            <v-card color="red" class="rounded-lg" dark>
              <v-card-text class="pa-0">
                <v-layout column>
                  <v-flex xs12 class="white--text text-center">
                    Clock Out
                  </v-flex>
                  <v-flex
                    xs12
                    class="white--text text-center display-1 font-weight-bold"
                  >
                    {{ count.clockOut }}
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <!-- <v-btn color="success" @click="startTest">start</v-btn>
      <v-btn color="success" @click="endTest">end</v-btn> -->
      <div class="mr-5 text-center" v-if="employees.length > 8">
        <v-btn-toggle class="ma-2 noscroll" style="background: #f3f3f3">
          <v-btn @click="alfClcik(al)" v-for="(al, index) in alf" :key="index">
            {{ al }}
          </v-btn>
        </v-btn-toggle>
      </div>

      <v-snackbar
        :timeout="-1"
        color="grey lighten-2"
        style="margin-bottom: 60px"
        rounded="pill"
        elevation="24"
        v-model="snackbar"
      >
        <div style="color: black">Search: {{ search }}</div>
        <template v-slot:action="{ attrs }">
          <v-btn icon color="pink" text v-bind="attrs" @click="backString">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <v-btn icon color="pink" text v-bind="attrs" @click="clearBtn">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
      </v-snackbar>
      <AddCard
        :openDialog="openCardCollectDialog"
        message="We currently do not have a payment method on file for you. Please provide your payment method information."
      />

      <CSPLoader :model="true" class="mt-5" v-if="timeClockLoaded" />

      <v-container grid-list-md class="pa-0 mt-3 touch-view-container" v-else>
        <div v-if="showDepartment && showDepartmentSetting">
          <div
            v-for="(department, i) in filteredItems"
            :key="department.departmentName"
          >
            <v-card color="primary" class="mt-2">
              <v-layout row wrap align-center>
                <v-flex xs6>
                  <v-chip
                    class="my-2 font-weight-bold"
                    label
                    color="primary"
                    text-color="white"
                    >{{ department.departmentName }}</v-chip
                  >
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex xs6 shrink class="text-right">
                  <v-chip
                    class="my-2 font-weight-bold text-right"
                    label
                    color="primary"
                    text-color="white"
                    >{{ department.employees.length }}</v-chip
                  >
                </v-flex>
              </v-layout>
            </v-card>

            <!-- :class="i === (filteredItems.length -1) ? 'pa-0 mt-3 touch-view-container' : 'pa-0 mt-3'" -->

            <swipe-list
              v-if="department.employees.length"
              ref="list"
              class="card"
              :items="department.employees"
              item-key="id"
              id="register-cart-list"
            >
              <template v-slot="{ item, index }">
                <v-list-item
                  :class="[
                    index % 2 === 0 ? 'even-background' : 'odd-background',
                  ]"
                >
                  <v-list-item-content @click="openQuickReport(item)">
                    <v-list-item-title class="subtitle-2">
                      <v-chip
                        v-if="
                          item.TimeClockPays && item.TimeClockPays.length > 0
                        "
                        x-small
                        label
                        color="pink lighten-4"
                        class="mr-1"
                        >{{ item.TimeClockPays.length }}</v-chip
                      >
                      <v-icon
                        small
                        color="green"
                        v-if="
                          item &&
                          item.metadata &&
                          item.metadata.fingerprintEnrolled
                        "
                      >
                        mdi-fingerprint
                      </v-icon>
                      <v-icon small color="red" v-else>
                        mdi-fingerprint-off
                      </v-icon>
                      <span class="text-capitalize">{{ item.name }}</span>
                    </v-list-item-title>
                    <v-list-item-subtitle v-if="item.phoneNumber">
                      <span class="caption">
                        {{ item.phoneNumber }}
                      </span>
                    </v-list-item-subtitle>
                    <v-list-item-subtitle
                      class="caption"
                      v-if="item.TimeClocks.length !== 0"
                    >
                      <div v-if="item.TimeClocks[0].status === 'clockedIn'">
                        {{ item.TimeClocks[0].clockInTime | moment("ddd") }} -
                        {{
                          item.TimeClocks[0].clockInTime
                            | moment("M/D/YY h:mm A")
                        }}
                      </div>
                      <div v-else>
                        {{ item.TimeClocks[0].clockOutTime | moment("ddd") }}
                        -
                        {{
                          item.TimeClocks[0].clockOutTime
                            | moment("M/D/YY h:mm A")
                        }}
                      </div>
                    </v-list-item-subtitle>
                    <!-- <v-list-item-subtitle v-if="item.phoneNumber">
                      <span class="caption">{{ item.phoneNumber }}</span>
                    </v-list-item-subtitle> -->
                  </v-list-item-content>
                  <v-list-item-action-text v-if="item.rowLoading">
                    <v-progress-circular
                      indeterminate
                      color="red"
                    ></v-progress-circular>
                  </v-list-item-action-text>
                  <div v-else>
                    <v-list-item-action-text
                      @click="instantClockInOut(item, index)"
                      v-if="item.TimeClocks.length === 0"
                    >
                      Never
                    </v-list-item-action-text>
                    <v-list-item-action-text
                      @click="instantClockInOut(item, index)"
                      v-else
                      class="text-right"
                    >
                      <div
                        class="font-weight-bold green--text text-right"
                        v-if="item.TimeClocks[0].status === 'clockedIn'"
                      >
                        <v-chip color="green" text-color="white">
                          IN
                          <v-avatar right class="green darken-4">
                            <v-icon>mdi-location-enter</v-icon>
                          </v-avatar>
                        </v-chip>
                      </div>

                      <div
                        v-if="item.TimeClocks[0].status === 'clockedIn'"
                        class="caption"
                      >
                        {{
                          item.TimeClocks[0].clockInTime | moment("from", "now")
                        }}
                      </div>

                      <div class="font-weight-bold red--text" v-else>
                        <v-chip color="red" text-color="white">
                          OUT
                          <v-avatar right class="red darken-4">
                            <v-icon>mdi-location-exit</v-icon>
                          </v-avatar>
                        </v-chip>
                      </div>
                    </v-list-item-action-text>
                  </div>
                </v-list-item>
                <v-divider
                  v-if="index + 1 < employees.length"
                  :key="index"
                ></v-divider>
              </template>

              <template
                v-slot:right="{ item, index, close }"
                v-if="
                  employeeAccess.timeClock && employeeAccess.timeClock.inOut
                "
              >
                <v-btn
                  color="error"
                  v-if="item.status === 'clockedIn'"
                  :loading="submitLoading"
                  class="ma-0 btn-size-45 tile"
                  style="height: 100%; min-width: 45px !important"
                  @click.stop.prevent="clockOutEmployee(item, index)"
                >
                  Clock Out
                </v-btn>
                <v-btn
                  v-else
                  color="green"
                  dark
                  :loading="submitLoading"
                  class="ma-0 btn-size-45 tile"
                  style="height: 100%; min-width: 45px !important"
                  @click.stop.prevent="clockInEmployee(item, index)"
                >
                  Clock In
                </v-btn>
                <v-btn
                  color="error"
                  class="ma-0 tile"
                  @click.stop.prevent="close"
                  style="height: 100%; min-width: 45px !important"
                >
                  <v-icon class="pa-3">mdi-close</v-icon>
                </v-btn>
              </template>

              <template
                v-slot:left="{ item, close }"
                v-if="
                  employeeAccess.employee && employeeAccess.employee.viewProfile
                "
              >
                <v-btn
                  v-if="!isReadOnly(item)"
                  color="primary"
                  dark
                  class="ma-0 btn-size-45 tile"
                  style="height: 100%; min-width: 45px !important"
                  @click.stop.prevent="openProfile(item)"
                >
                  Open Profile
                </v-btn>
                <v-btn
                  color="info"
                  class="ma-0 tile"
                  @click.stop.prevent="close"
                  style="height: 100%; min-width: 45px !important"
                >
                  <v-icon class="pa-3">mdi-close</v-icon>
                </v-btn>
              </template>
            </swipe-list>
            <v-layout row column v-else fill-height align-center justify-center>
              <v-flex shrink>
                <p class="px-5 text-center">
                  It looks like you're starting fresh. To get things rolling, go
                  ahead and add your very first employee. Just click the
                  <a class="font-weight-bold" @click="createEmployee">Here</a>
                  or 'Add Employee' button to begin. We're here to help if you
                  have any questions along the way. Happy onboarding!
                </p>
              </v-flex>
              <v-flex shrink>
                <v-btn
                  @click="createEmployee"
                  class="mt-5 px-10"
                  color="primary"
                  rounded
                  x-large
                  >Add Employee</v-btn
                >
              </v-flex>
            </v-layout>
          </div>
        </div>

        <div v-else>
          <swipe-list
            v-if="filteredItems.length"
            ref="list"
            class="card"
            :items="filteredItems"
            item-key="id"
            id="register-cart-list"
          >
            <template v-slot="{ item, index }">
              <v-list-item
                :class="[
                  index % 2 === 0 ? 'even-background' : 'odd-background',
                ]"
              >
                <v-list-item-content @click="openQuickReport(item)">
                  <v-list-item-title class="subtitle-2">
                    <v-chip
                      v-if="item.TimeClockPays && item.TimeClockPays.length > 0"
                      x-small
                      label
                      color="pink lighten-4"
                      class="mr-1"
                      >{{ item.TimeClockPays.length }}</v-chip
                    >
                    <v-icon
                      small
                      color="green"
                      v-if="
                        item &&
                        item.metadata &&
                        item.metadata.fingerprintEnrolled
                      "
                    >
                      mdi-fingerprint
                    </v-icon>
                    <v-icon small color="red" v-else>
                      mdi-fingerprint-off
                    </v-icon>
                    <span class="text-capitalize">{{ item.name }}</span>
                  </v-list-item-title>
                  <v-list-item-subtitle v-if="item.phoneNumber">
                    <span class="caption">
                      {{ item.phoneNumber }}
                    </span>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle
                    class="caption"
                    v-if="item.TimeClocks.length !== 0"
                  >
                    <div v-if="item.TimeClocks[0].status === 'clockedIn'">
                      {{ item.TimeClocks[0].clockInTime | moment("ddd") }} -
                      {{
                        item.TimeClocks[0].clockInTime | moment("M/D/YY h:mm A")
                      }}
                    </div>
                    <div v-else>
                      {{ item.TimeClocks[0].clockOutTime | moment("ddd") }}
                      -
                      {{
                        item.TimeClocks[0].clockOutTime
                          | moment("M/D/YY h:mm A")
                      }}
                    </div>
                  </v-list-item-subtitle>
                  <!-- <v-list-item-subtitle v-if="item.phoneNumber">
                    <span class="caption">{{ item.phoneNumber }}</span>
                  </v-list-item-subtitle> -->
                </v-list-item-content>
                <v-list-item-action-text v-if="item.rowLoading">
                  <v-progress-circular
                    indeterminate
                    color="red"
                  ></v-progress-circular>
                </v-list-item-action-text>
                <div v-else>
                  <v-list-item-action-text
                    @click="instantClockInOut(item, index)"
                    v-if="item.TimeClocks.length === 0"
                  >
                    Never
                  </v-list-item-action-text>
                  <v-list-item-action-text
                    @click="instantClockInOut(item, index)"
                    v-else
                    class="text-right"
                  >
                    <div
                      class="font-weight-bold green--text text-right"
                      v-if="item.TimeClocks[0].status === 'clockedIn'"
                    >
                      <v-chip color="green" text-color="white">
                        IN
                        <v-avatar right class="green darken-4">
                          <v-icon>mdi-location-enter</v-icon>
                        </v-avatar>
                      </v-chip>
                    </div>

                    <div
                      v-if="item.TimeClocks[0].status === 'clockedIn'"
                      class="caption"
                    >
                      {{
                        item.TimeClocks[0].clockInTime | moment("from", "now")
                      }}
                    </div>

                    <div class="font-weight-bold red--text" v-else>
                      <v-chip color="red" text-color="white">
                        OUT
                        <v-avatar right class="red darken-4">
                          <v-icon>mdi-location-exit</v-icon>
                        </v-avatar>
                      </v-chip>
                    </div>
                  </v-list-item-action-text>
                </div>
              </v-list-item>
              <v-divider
                v-if="index + 1 < employees.length"
                :key="index"
              ></v-divider>
            </template>

            <template
              v-slot:right="{ item, index, close }"
              v-if="employeeAccess.timeClock && employeeAccess.timeClock.inOut"
            >
              <v-btn
                color="error"
                v-if="item.status === 'clockedIn'"
                :loading="submitLoading"
                class="ma-0 btn-size-45 tile"
                style="height: 100%; min-width: 45px !important"
                @click.stop.prevent="clockOutEmployee(item, index)"
              >
                Clock Out
              </v-btn>
              <v-btn
                v-else
                color="green"
                dark
                :loading="submitLoading"
                class="ma-0 btn-size-45 tile"
                style="height: 100%; min-width: 45px !important"
                @click.stop.prevent="clockInEmployee(item, index)"
              >
                Clock In
              </v-btn>
              <v-btn
                color="error"
                class="ma-0 tile"
                @click.stop.prevent="close"
                style="height: 100%; min-width: 45px !important"
              >
                <v-icon class="pa-3">mdi-close</v-icon>
              </v-btn>
            </template>

            <template
              v-slot:left="{ item, close }"
              v-if="
                employeeAccess.employee && employeeAccess.employee.viewProfile
              "
            >
              <v-btn
                v-if="!isReadOnly(item)"
                color="primary"
                dark
                class="ma-0 btn-size-45 tile"
                style="height: 100%; min-width: 45px !important"
                @click.stop.prevent="openProfile(item)"
              >
                Open Profile
              </v-btn>
              <v-btn
                color="info"
                class="ma-0 tile"
                @click.stop.prevent="close"
                style="height: 100%; min-width: 45px !important"
              >
                <v-icon class="pa-3">mdi-close</v-icon>
              </v-btn>
            </template>
          </swipe-list>

          <v-layout row column v-else fill-height align-center justify-center>
            <v-flex shrink>
              <p class="px-5 text-center">
                It looks like you're starting fresh. To get things rolling, go
                ahead and add your very first employee. Just click the
                <a class="font-weight-bold" @click="createEmployee">Here</a> or
                'Add Employee' button to begin. We're here to help if you have
                any questions along the way. Happy onboarding!
              </p>
            </v-flex>
            <v-flex shrink>
              <v-btn
                @click="createEmployee"
                class="mt-5 px-10"
                color="primary"
                rounded
                x-large
                >Add Employee</v-btn
              >
            </v-flex>
          </v-layout>
        </div>
      </v-container>
    </div>
    <ClockInOut
      :dialog="dialog"
      :selectedRow="selectedRow"
      @submit="submitWithClockIn"
      @cancel="cancel"
    />

    <Profile
      @close="close"
      :dialog="profileDialog"
      :employee="selectedEmployeeRow"
    />

    <QuickReport
      @close="closeQuickReport"
      :dialog="quickReportDialog"
      :selectedRow="selectedRow"
    />
  </div>
</template>

<script>
// eslint-disable-line no-mixed-spaces-and-tabs
// import Appbar from "@/components/Appbar";
import ChangeLocation from "@/modules/Home/components/LocationChange.vue";
import locationService from "@/modules/Location/service.js";
import DateTimeTextField from "@/components/DateTimeTextField.vue";
import employeeService from "@/modules/Employee/service";
import timeClockService from "@/modules/TimeClock/service.js";
import { SwipeList, SwipeOut } from "vue-swipe-actions";
import "vue-swipe-actions/dist/vue-swipe-actions.css";
import Profile from "@/modules/Employee/components/Profile.vue";
import ClockInOut from "@/modules/Home/components/ClockInOut.vue";
import { mapActions, mapGetters } from "vuex";
import QuickReport from "@/modules/Reports/components/QuickReport.vue";
import AddCard from "@/modules/Location/components/AddMissingCard.vue";

export default {
  name: "home",
  data() {
    return {
      showDepartment: false,
      showDepartmentSetting: false,
      customer: null,
      openCardCollectDialog: false,
      location: null,
      snackbar: false,
      quickReportDialog: false,
      search: "",
      subscription: null,
      recentLocation: null,
      groupedEmployees: [],
      picture: "",
      submitLoading: false,
      profileDialog: false,
      timeClockLoaded: true,
      selectedRowIndex: null,
      selectedEmployeeRow: null,
      selectedRow: null,
      dialog: false,
      locationCode: null,
      location: null,
      deviceCode: null,
      deviceName: null,
      employees: [],
      loading: false,
      selectedEmployee: null,
      clockedInEmployees: [],
      clockedOutEmployees: [],
      count: {
        clockIn: 0,
        clockOut: 0,
      },
      alf: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
      ],
    };
  },
  components: {
    AddCard,
    ChangeLocation,
    ClockInOut,
    Profile,
    QuickReport,
    SwipeOut,
    SwipeList,
    DateTimeTextField,
  },
  sockets: {
    employeeStatusChange(val) {
      console.log("employeeStatusChange", val);
      this.getEmployeesList();
    },
  },
  watch: {
    search(val) {
      if (val.length === 0) {
        this.showDepartment = true;
        this.snackbar = false;
      } else {
        this.showDepartment = false;
      }
    },
  },
  computed: {
    ...mapGetters("employee", ["employee", "employeeAccess"]),
    filteredItems() {
      if (this.search) {
        return this.employees.filter((item) => {
          return (
            item.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1
          );
        });
      } else {
        if (
          !this.groupedEmployees.length ||
          this.groupedEmployees.length === 1 ||
          !this.showDepartmentSetting
        ) {
          return this.employees;
        } else {
          return this.groupedEmployees;
        }
      }
    },
  },
  async created() {
    let localLocation = localStorage.getItem(
      `${process.env.VUE_APP_STORAGE_PREFIX}location`
    );

    if (localLocation) {
      localLocation = JSON.parse(localLocation);
      // console.log("location", localLocation);

      locationService.Terminal.getById(localLocation.id).then((response) => {
        // console.log('respond Terminal', response)
        this.location = response.data;
        if (
          this.location &&
          this.location.metadata &&
          this.location.metadata.isLocked
        ) {
          this.$router.push({
            name: "no-subscription",
            params: {
              // subscription: this.subscription,
              location: this.Location,
            },
          });
        }
        if (
          this.location &&
          this.location.metadata &&
          this.location.metadata.customClockIn &&
          this.location.metadata.customClockIn.showDepartment
        ) {
          this.showDepartmentSetting = true;
        } else {
          this.showDepartmentSetting = false;
        }
      });
    }

    this.recentLocation = JSON.parse(
      localStorage.getItem(
        `${process.env.VUE_APP_STORAGE_PREFIX}recentLocation`
      )
    );
    if (!this.recentLocation) this.recentLocation = [];
    this.location = JSON.parse(
      localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}location`)
    );

    this.getEmployeesList();
    await this.loadCustomer();
    // console.log('this.subscriptionthis.subscription', this.subscription)
    if (
      this.customer &&
      this.customer.metadata &&
      !this.customer.metadata.free
    ) {
      await this.loadCardOnFile();
    }
    await this.loadSubscription();
  },
  methods: {
    ...mapActions("employee", ["setEmployee"]),
    ...mapActions("global", ["setLocation"]),
    startTest() {
      timeClockService
        .restrictiveTime()
        .then(async (result) => {
          console.log("result", result);
        })
        .catch((err) => {
          this.$toast.error(err.data ? err.data.message : "Error", {
            timeout: 3000,
          });
          this.submitLoading = false;
          console.log(err ? err.message : err);
        });
    },
    endTest() {
      timeClockService
        .restrictiveTime()
        .then(async (result) => {
          console.log("result", result);
        })
        .catch((err) => {
          this.$toast.error(err.data ? err.data.message : "Error", {
            timeout: 3000,
          });
          this.submitLoading = false;
          console.log(err ? err.message : err);
        });
    },
    createEmployee() {
      this.$router.push({ name: "employee-create" });
    },
    // if selected employee is owner and its not editing himself then make it readOnly
    isReadOnly(selectedEmployee) {
      if (selectedEmployee.owner && this.employee.id != selectedEmployee.id)
        return true;
      else return false;
    },
    closeQuickReport() {
      console.log("quick report close");
      this.quickReportDialog = false;
    },
    openQuickReport(row) {
      if (
        this.employeeAccess.timeClock &&
        !this.employeeAccess.timeClock.instantReport
      ) {
        return false;
      }
      console.log("item val", row);
      this.selectedRow = row;
      this.quickReportDialog = !this.quickReportDialog;
    },
    backString() {
      this.search = this.search.substring(0, this.search.length - 1);
    },
    clearBtn() {
      this.snackbar = false;
      this.search = "";
    },
    alfClcik(lat) {
      this.snackbar = true;
      // console.log("lat press", this.search, lat);
      this.search += lat;
    },
    instantClockInOut(item) {
      console.log("item", this.employeeAccess);
      if (
        this.employeeAccess.timeClock &&
        !this.employeeAccess.timeClock.instant
      ) {
        return false;
      }

      item.rowLoading = true;
      let selectedRow = {};

      if (item.TimeClocks.length) {
        selectedRow = item.TimeClocks[0];
        if (selectedRow.status === "clockedIn") {
          selectedRow.clockOutTime = this.$moment();
          selectedRow.admin = true;
          console.log("clock out");
          timeClockService
            .clockOut(selectedRow)
            .then(async () => {
              await this.getEmployeesList();
              item.rowLoading = false;
            })
            .catch((err) => {
              this.$toast.error(err.data ? err.data.message : "Error", {
                timeout: 3000,
              });
              this.submitLoading = false;
              console.log(err ? err.message : err);
            });
        } else {
          selectedRow.clockInTime = this.$moment();
          selectedRow.admin = true;
          console.log("clock in");
          timeClockService
            .clockIn(selectedRow)
            .then(async () => {
              await this.getEmployeesList();
              item.rowLoading = false;
            })
            .catch((err) => {
              this.$toast.error(err.data ? err.data.message : "Error", {
                timeout: 3000,
              });
              this.submitLoading = false;
              console.log(err ? err.message : err);
            });
        }
      } else {
        console.log("never was enter");
        selectedRow.clockInTime = this.$moment();
        selectedRow.admin = true;
        selectedRow.EmployeeId = item.id;
        console.log("clock in");
        timeClockService
          .clockIn(selectedRow)
          .then(async () => {
            await this.getEmployeesList();
            item.rowLoading = false;
          })
          .catch((err) => {
            this.$toast.error(err.data ? err.data.message : "Error", {
              timeout: 3000,
            });
            this.submitLoading = false;
            console.log(err ? err.message : err);
          });
      }
    },
    loadCardOnFile() {
      const location = JSON.parse(
        localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}location`)
      );
      if (location) {
        return locationService
          .getCards(location.id)
          .then(async (response) => {
            // console.log('response sb card', response)
            if (response.data.data.length === 0) {
              this.openCardCollectDialog = !this.openCardCollectDialog;
            }
            // console.log("loadCardOnFile", response);
          })
          .catch((error) => {
            console.log("loadCardOnFile error", error);
          });
      }
    },
    loadSubscription() {
      const location = JSON.parse(
        localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}location`)
      );
      // console.log("location", location);
      if (location) {
        return locationService
          .getSubscription()
          .then(async (response) => {
            // console.log("sub", response);

            this.subscription = response.data[0];
            // console.log('this.subscription', this.subscription)
            if (this.subscription) {
              // if (this.subscription.status === 'canceled') {
              //   this.$router.push({
              //     name: "no-subscription",
              //     params: {
              //       location: location,
              //     }
              //   });
              // }
              let total = 0;
              this.subscription.items.data.map((row) => {
                if (row.price.metadata && row.price.metadata.employeeCount) {
                  // console.log("row", row.price.metadata);
                  total +=
                    parseInt(row.price.metadata.employeeCount) * row.quantity;
                }
              });
              // console.log("total ", total);
              if (total !== 0) {
                this.employeeCountAllow = total;
              }
            }
            // else {
            //   this.$router.push({
            //     name: "no-subscription",
            //     params: {
            //       location: this.Location,
            //     },
            //   });
            // }
          })
          .catch((error) => {
            console.log("load sub2", error);
          });
      }
    },
    loadCustomer() {
      const location = JSON.parse(
        localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}location`)
      );

      if (location) {
        return locationService
          .getCustomer()
          .then(async (response) => {
            // console.log('responserespons customer', response)
            this.customer = response.data;
          })
          .catch((error) => {
            console.log("load sub2", error);
          });
      }
    },
    openProfile(obj) {
      // console.log("profile", obj);
      this.selectedEmployeeRow = obj;
      this.profileDialog = true;
    },
    cancel() {
      this.selectedRow.clockOutTime = null;
      this.selectedRowIndex = null;
      // this.$refs.list.closeActions(0);
      this.$refs.list.closeActions();
      // console.log('list', this.$refs.list)
      // this.$refs.list.forEach(row => {
      //   row.closeActions();
      // })
      this.submitLoading = false;
      this.dialog = false;
    },
    close() {
      this.profileDialog = false;

      this.$refs.list.forEach((row) => {
        row.closeActions();
      });
    },
    submitWithClockIn() {
      this.submitLoading = false;
      this.dialog = false;
      // this.$refs.list.closeActions();
      this.getEmployeesList();
    },
    clockOutEmployee(e, i) {
      this.submitLoading = true;
      // this.selectedRow.clockOutTime = this.$moment();
      this.selectedRow = e.TimeClocks[0];
      this.selectedRowIndex = i;
      this.dialog = true;
    },
    clockInEmployee(e, i) {
      let clockIn = {
        status: e.status,
        PinCode: e.pinCode,
        clockInTime: this.$moment(),
      };
      if (e.TimeClocks.length !== 0) {
        clockIn.EmployeeId = e.TimeClocks[0].EmployeeId;
      } else {
        clockIn.EmployeeId = e.id;
      }
      this.selectedRow = clockIn;
      // {
      //   EmployeeId: (e.TimeClocks[0].EmployeeId ? e.id : e.TimeClocks[0].EmployeeId),
      //   status: e.status,
      //   PinCode: e.pinCode,
      //   clockInTime: this.$moment(),
      // };
      this.selectedRowIndex = i;
      this.dialog = true;
    },
    getEmployeesList() {
      // console.log('currentEmployee', this.employeeAccess)
      return employeeService
        .getAll({
          timeClock: true,
          limit: 50,
          offset: 0,
          local: true,
        })
        .then(async (response) => {
          let employee = response.data;
          console.log("employee", employee);
          this.employees = [];
          this.groupedEmployees = [];
          this.count = {
            clockIn: 0,
            clockOut: 0,
          };
          employee.map((row) => {
            row.rowLoading = false;
            if (
              row.metadata &&
              row.metadata.timeClockLogin &&
              row.metadata.timeClockLogin.employee
            ) {
              if (row.TimeClocks.length > 0) {
                row.status = row.TimeClocks[0].status;
                if (row.status === "clockedIn") {
                  this.count.clockIn++;
                } else {
                  this.count.clockOut++;
                }
              } else {
                row.status = "never";
              }
              if (this.employeeAccess.onlyView) {
                this.employeeAccess.onlyViewEmployee.map((emp) => {
                  if (emp === row.id) {
                    this.employees.push(row);
                  }
                });
              } else {
                this.employees.push(row);
              }
            }
          });
          if (this.showDepartmentSetting === true) {
            const grouped = this.employees.reduce((acc, employee) => {
              const deptId = employee.DepartmentId
                ? employee.DepartmentId
                : "Unassigned";
              if (!acc[deptId]) {
                acc[deptId] = {
                  departmentName: employee.Department
                    ? employee.Department.name
                    : "Unassigned",
                  employees: [],
                };
              }
              acc[deptId].employees.push(employee);
              return acc;
            }, {});

            const sortedDepartments = Object.values(grouped).sort((a, b) =>
              a.departmentName.localeCompare(b.departmentName)
            );

            sortedDepartments.forEach((department) => {
              department.employees.sort((a, b) => a.name.localeCompare(b.name));
            });

            this.groupedEmployees = sortedDepartments;

            if (this.groupedEmployees.length === 1) {
              this.showDepartment = false;
            } else {
              this.showDepartment = true;
            }
          }

          this.timeClockLoaded = false;
          // console.log("employees", this.groupedEmployees);
        })
        .catch((error) => {
          this.timeClockLoaded = false;
          throw error;
        });
    },
  },
};
</script>

<style scoped>
.card-labels {
  display: block;
}

/* .touch-view-container {
  width: 100%;
  overflow: auto;
} */

.touch-view-container {
  height: calc(100vh - 370px);
  width: 100%;
  overflow: auto;
}

.noscroll {
  overflow-y: scroll;
}

div::-webkit-scrollbar {
  display: none;
  /* for Chrome, Safari, and Opera */
}
</style>
